import { Badge } from 'avo-ui'
import { Link } from 'react-router-dom'
import { formatDateMoment, setCurrency, setNumberWithPoint } from 'utils/utils'
import icImageDefault from 'assets/images/ic-image-x.svg'

export const TABLE_PRODUCT = {
    name: 'Product',
    column: [
        {
            name: 'Product',
            key: 'product',
            render: ({ item }) => (
                <Link
                    to={`/product/product-list/update-product?productId=${item?.id}`}
                    className={'flex flex-row gap-3 items-center'}
                >
                    <img className={'w-7 h-7'} src={item?.image_url || icImageDefault} alt={item?.name} />
                    <div className={'capitalize font-medium text-blue-90 hover:font-bold hover:underline'}>
                        {item?.name}
                    </div>
                </Link>
            ),
        },
        {
            name: 'SKU',
            key: 'sku',
            className: 'max-w-[300px] break-words',
        },
        {
            name: 'Brand',
            key: 'brand_name',
            className: 'capitalize',
        },
        {
            name: 'Category',
            key: 'categories',
            className: 'capitalize',
            render: ({ value }) => <div>{value?.replace(/,/g, ', ')}</div>,
        },
        {
            name: 'Price',
            key: 'price',
            render: ({ item }) => (
                <div className={'space-y-2'}>
                    <p className={!!item.sale_price && 'line-through'}>{setCurrency(item.price)}</p>
                    {!!item.sale_price && <p className={'font-semibold'}>{setCurrency(item.sale_price)}</p>}
                </div>
            ),
        },
        {
            name: 'Stock',
            key: 'stock_quantity',
            render: ({ value }) => <div>{value ? setNumberWithPoint(value) : '-'}</div>,
        },
        {
            name: 'Last Modified',
            key: 'updated_at',
            render: ({ value }) => <div>{formatDateMoment(value, 'DD/MM/YYYY HH:mm')}</div>,
        },
        {
            name: 'Status',
            key: 'status',
            render: ({ value }) => <Badge title={value} type={value} />,
        },
    ],
}

export const INITIAL_DATA_FILTER = {
    search: '',
    page: 1,
    limit: 20,
    order_by: 'created_at',
    order_type: 'desc',
}

export const INITIAL_ADVANCE_FILTER = {
    category_ids: [],
    brand_ids: [],
    type_ids: [],
    status: [],
}

export const FILTER_PARAMS = ['category_ids', 'brand_ids', 'type_ids', 'status']

export const SORT_PRODUCT = [
    {
        label: 'Sort By Name Desc',
        key: 'name-desc',
        name: 'sort-product',
    },
    {
        label: 'Sort By Name Asc',
        key: 'name-asc',
        name: 'sort-product',
    },
    {
        label: 'Sort By Price Desc',
        key: 'price-desc',
        name: 'sort-product',
    },
    {
        label: 'Sort By Price Asc',
        key: 'price-asc',
        name: 'sort-product',
    },
    {
        label: 'Sort By Created At Desc',
        key: 'created_at-desc',
        name: 'sort-product',
    },
    {
        label: 'Sort By Created At Asc',
        key: 'created_at-asc',
        name: 'sort-product',
    },
]
